export default __webpack_public_path__ + "static/media/Joel.e19530b2.jpg";